import { useTranslation } from 'react-i18next';

import { compiledPaths } from '../../../paths';
import { isDefined } from '../../../utils/is';
import { Input } from '../../various/Fields/Input';
import { FieldWrapper } from '../../various/Form';
import { Skeleton } from '../../various/Skeleton';

interface Props {
  isPending: boolean;
  lookbookId: string;
  wishlistId?: string;
}

export const WishlistShareLinkInput = ({ wishlistId, lookbookId, isPending }: Props) => {
  const { t } = useTranslation(['selections', 'lookbook']);

  return (
    <FieldWrapper label={t('selections:shareable_link')}>
      {isPending ?
        <Skeleton type="input" />
      : <Input
          size="large"
          value={`${window.location.origin}${compiledPaths.LOOKBOOK_WISHLIST_PAGE({ lookbookId, wishlistId })}`}
          isReadonly
          isCopyable={isDefined(wishlistId)}
          onFocus={event => event.target.select()}
      />
      }
    </FieldWrapper>
  );
};
